import { combineReducers } from 'redux'
import userReducer from '../user/reducer'
import appReducer from '../submissions/reducer'
import submissionsReducer from '../reducers/submissionReducer'
import adminReducer from '../reducers/adminReducer'
import alertReducer from '../reducers/alertReducer'

import { alertsReducer } from '../alerts'
import { brokeragesReducer } from '../brokerages'
import { clearanceReducer } from '../clearance'
import { invitesReducer } from '../invites'
import { personReducer } from '../person'
import { upsellReducer } from '../upsell'
import { ratingsReducer } from '../ratings'
import { usersReducer } from '../users'
import { underWriterReducer } from '../underwriter'
import { deductiblesReducer } from '../deductibles'

import { uploadWhitelistReducer } from '../uploadWhitelist'

import { reducers as authReducer } from '../auth/reducers'

export const createRootReducer = () =>
  combineReducers({
    ...uploadWhitelistReducer,
    auth: authReducer,
    admin: adminReducer,
    alert: alertReducer,
    alerts: alertsReducer,
    app: appReducer,
    brokerages: brokeragesReducer,
    clearance: clearanceReducer,
    invites: invitesReducer,
    submissions: submissionsReducer,
    user: userReducer,
    users: usersReducer,
    upsell: upsellReducer,
    ratings: ratingsReducer,
    person: personReducer,
    underwriter: underWriterReducer,
    deductibles: deductiblesReducer,
  })
